import { createFileRoute, redirect } from '@tanstack/react-router';

// The URL this page was reachable at before FPS-2871 renamed it. Replaces rather
// than pushes, so Back leaves the section instead of bouncing forward again.
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/actions/messaging_limit')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/workspaces/$workspaceId/settings/actions/message_frequency_limits',
      params: { workspaceId: params.workspaceId },
      replace: true,
    });
  },
});
